// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3A9e9","boxTitle":"Qualiphy_boxTitle__3KYlZ","box":"Qualiphy_box__OcD1x","toggleWrap":"Qualiphy_toggleWrap__2DnKf"};